import type { AccountSegment } from '../types/segment';

/**
 * Returns a SOQL WHERE clause fragment for segment filtering.
 * @param segment - 'all' | 'onboarding' | 'onboarded'
 * @param prefix - '' for Account queries, 'Account' for Opportunity/Contact queries
 */
export function segmentWhereClause(segment: AccountSegment, prefix = ''): string {
  if (segment === 'all') return '';
  const field = prefix ? `${prefix}.Total_Plans_Sold__c` : 'Total_Plans_Sold__c';
  return segment === 'onboarded'
    ? ` AND ${field} >= 7`
    : ` AND (${field} = null OR ${field} < 7)`;
}
